import "./styles.scss";

import { useState } from "react";
import queryString from "query-string";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import Button from "components/Button";
import CreateTask from "components/CreateTask";
import TaskOnboarding from "components/TaskOnboarding";
import SendNotification from "components/SendNotification";
import CreateClientTask from "components/CreateClientTask";

import useResponsive from "libs/helpers/useResponsive";

const mainClass = "dashboard-layout-actions";

const button_render = (item, onboarding) => {
  switch (item?.type) {
    case "send_notification":
      return <SendNotification />;
    case "create_task":
      return <CreateTask />;
    case "create_client_task":
      return <CreateClientTask onboarding={onboarding} />;

    default:
      return (
        <Button
          variant={item?.variant}
          href={item?.href || null}
          onClick={
            item?.onclick
              ? () => {
                  item?.onclick();
                  !!item?.event && item?.event();
                }
              : null
          }
        >
          {item?.icon && <i>{item.icon}</i>}
          <span>{item?.label}</span>
        </Button>
      );
  }
};

const Actions = ({ data }) => {
  const { t } = useTranslation();
  const { pathname, search } = useLocation();
  const query = queryString.parse(search);
  const { max } = useResponsive();

  const [onboarding, setOnboarding] = useState(
    query?.onboarding === "new" && !query?.referrer,
  );

  const onOnboardingClose = () => {
    setOnboarding(false);

    window.history.replaceState({}, null, pathname);
  };

  const fixed_data = data?.filter((item) => (max.sm ? !item?.type : true));

  if (!(fixed_data?.length > 0)) return null;

  return (
    <>
      <div className={mainClass}>
        <div className={`${mainClass}__items`}>
          {fixed_data?.map((item, index) => (
            <div
              key={`${item?.type ?? item?.label ?? "action"}_${item?.variant ?? "default"}_${index}`}
              className={item?.onboarding_button ? "onboarding_button" : ""}
            >
              {button_render(item, onboarding)}
              {item?.onboarding_button && !!!onboarding && (
                <>
                  <button
                    className={`${mainClass}__helper-button`}
                    onClick={() => setOnboarding(true)}
                  >
                    <div>?</div>
                  </button>
                  <div className={`${mainClass}__helper-button__active`}>
                    <Button fullWidth onClick={() => setOnboarding(true)}>
                      {t("How it works")}?
                    </Button>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
      {!!onboarding && <TaskOnboarding onClose={onOnboardingClose} />}
    </>
  );
};

export default Actions;
